import { ModalLogin } from "components/login/modalLogin";
import * as message from "components/message/message";
import { Action } from "./actions";
import { Cursor } from "./cursor";
import $ from "jquery";

class ErrorCallback {
    private action: Action;
    constructor(action: Action) {
        this.action = action;
    }
    public errorCallback = (jqXHR, textStatus, errorThrown) => {
        Cursor.end();
        let event = new CustomEvent(
            "sislogActionEvent",
            {
                detail: {
                    phase: "finish",
                    action: this.action,
                },
            });
        document.dispatchEvent(event);
        if (textStatus === "abort") {
            return;
        }
        if (jqXHR.status === 400) {
            let response = $.parseJSON(jqXHR.responseText);
            response.status = "error";
            //                action._defaultResponseActionRunner(action, response);
        } else if (jqXHR.status === 401) {
            ModalLogin.open({
                title: "hello",
                url: "/login",
                callback: this.action._acceptCallback,
            });
        } else if (jqXHR.status === 403) {
            message.show({
                level: "error",
                key: "error.not_authorized",
            });
        } else if (jqXHR.status === 404) {
            message.show({
                level: "error",
                key: "error.not_found",
            });
            console.error(errorThrown);
        } else {
            if (jqXHR.responseJSON == null) {
                try {
                    let response = JSON.parse(jqXHR.responseText);
                    $.each(response.messages, (key, val) => {
                        message.show(val);
                    });
                } catch (e) {
                    message.show({
                        level: "error",
                        key: "Ops, something is wrong!",
                    });
                    console.error(errorThrown);
                }
            } else {
                let response = jqXHR.responseJSON;
                $.each(response.messages, (key, val) => {
                    message.show(val);
                });
            }
        }
}

}
const getErrorCallback = (action: Action) => {
    const errorCallback = new ErrorCallback(action);
    return errorCallback.errorCallback;
};


export { getErrorCallback };
